import styles from "./FullScreenMobilePage.module.scss";

import allariaLogo from "../../assets/images/icons/navbar/navbar-allaria-desktop-logo.svg";

interface Props {
  children: React.ReactNode;
  headerContent?: string;
  footerContent?: React.ReactNode;
  noLogo?: boolean;
}

const FullScreenMobilePage = (props: Props) => {
  const { container, logo, header, body, footer } = styles;
  const { children, headerContent, footerContent, noLogo } = props;

  return (
    <div className={container}>
      {!noLogo && (
        <div className={logo}>
          <img src={allariaLogo} alt="Allaria Logo" />
        </div>
      )}
      {headerContent && (
        <div className={header}>
          <h1>{headerContent}</h1>
        </div>
      )}

      <div className={body}>{children}</div>
      {footerContent && <div className={footer}>{footerContent}</div>}
    </div>
  );
};

export default FullScreenMobilePage;
